import { render, staticRenderFns } from "./semantic_rows.vue?vue&type=template&id=72a76fbc&scoped=true&lang=html"
import script from "./semantic_rows.vue?vue&type=script&lang=js"
export * from "./semantic_rows.vue?vue&type=script&lang=js"
import style0 from "./semantic_rows.vue?vue&type=style&index=0&id=72a76fbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a76fbc",
  null
  
)

export default component.exports